import { Button as ButtonAD } from 'antd';
import cs from 'classnames';
import { type FC, type ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

export type ButtonPropertiesOverride = ComponentProps<typeof ButtonAD> & {
  fullWidth?: boolean;
  'data-test-id'?: string;
};

export type ButtonProperties = {
  item?: ButtonPropertiesOverride;
  id?: string;
};

const defaultItem: ButtonPropertiesOverride = {};

const Button: FC<ButtonProperties> = ({ item: { fullWidth, className, ...item } = defaultItem, children, ...rest }) => {
  const { t } = useTranslation();

  return (
    <ButtonAD className={cs(className, { 'ui-button--full-width': fullWidth })} {...item} {...rest}>
      {typeof children === 'string' ? t(children) : children}
    </ButtonAD>
  );
};

export default Button;
